import { render, staticRenderFns } from "./ConsentCheckbox.vue?vue&type=template&id=0e1d28e6&scoped=true"
import script from "./ConsentCheckbox.vue?vue&type=script&lang=js"
export * from "./ConsentCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ConsentCheckbox.vue?vue&type=style&index=0&id=0e1d28e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1d28e6",
  null
  
)

export default component.exports